import type { Vec2 } from './types';

export interface PressureImpulse {
  readonly equalizedPressure: 'pressurized' | 'vacuum';
  readonly fromHighToLow: Vec2;
}

export function pressureEqualizationImpulse(
  from: 'pressurized' | 'vacuum',
  to: 'pressurized' | 'vacuum',
  normalFromTo: Vec2,
  impulseMagnitude = 7.5,
): PressureImpulse | null {
  if (from === to) return null;
  const direction = from === 'pressurized' ? 1 : -1;
  const length = Math.hypot(normalFromTo.x, normalFromTo.y) || 1;
  return {
    equalizedPressure: 'vacuum',
    fromHighToLow: {
      x: (normalFromTo.x / length) * impulseMagnitude * direction,
      y: (normalFromTo.y / length) * impulseMagnitude * direction,
    },
  };
}
